module.exports = __webpack_public_path__ + "static/media/VisbyCF-DemiBold.7ca16a98.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/VisbyCF-DemiBold.woff
// module id = 797
// module chunks = 0